'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var EDIT_ITEM = exports.EDIT_ITEM = 'hooks/EDIT_ITEM';
var START_CREATE_ITEM = exports.START_CREATE_ITEM = 'hooks/START_CREATE_ITEM';
var END_CREATE_ITEM = exports.END_CREATE_ITEM = 'hooks/END_CREATE_ITEM';
var CREATE_SCHEMA = exports.CREATE_SCHEMA = 'hooks/CREATE_SCHEMA';
var UPDATE_SCHEMA = exports.UPDATE_SCHEMA = 'hooks/UPDATE_SCHEMA';
var UPDATE_JSONSCHEMA = exports.UPDATE_JSONSCHEMA = 'hooks/UPDATE_JSONSCHEMA';
var UPDATE_UISCHEMA = exports.UPDATE_UISCHEMA = 'hooks/UPDATE_UISCHEMA';
var REMOVE_SCHEMA = exports.REMOVE_SCHEMA = 'hooks/REMOVE_SCHEMA';
var COPY_SCHEMA = exports.COPY_SCHEMA = 'hooks/COPY_SCHEMA';
var SET_CONFIRM_REMOVE = exports.SET_CONFIRM_REMOVE = 'hooks/SET_CONFIRM_REMOVE';
var CLEAR_CONFIRM_REMOVE = exports.CLEAR_CONFIRM_REMOVE = 'hooks/CLEAR_CONFIRM_REMOVE';
var GET_ALL_SCHEMAS = exports.GET_ALL_SCHEMAS = 'hooks/GET_ALL_SCHEMAS';
var GET_ALL_SCHEMAS_SUCCESS = exports.GET_ALL_SCHEMAS_SUCCESS = 'hooks/GET_ALL_SCHEMAS_SUCCESS';
var GET_ALL_HOOKS = exports.GET_ALL_HOOKS = 'hooks/GET_ALL_HOOKS';
var GET_ALL_HOOKS_SUCCESS = exports.GET_ALL_HOOKS_SUCCESS = 'hooks/GET_ALL_HOOKS_SUCCESS';


//////////////////
// WEBPACK FOOTER
// ./~/form-service/frontend/lib/components/Forms/actionTypes.js
// module id = 775
// module chunks = 5